    uniform vec2 uFrequency;
    uniform float uTime;


    varying vec2 vUv;
    varying float vElevation;


    // varying float vRandom;

    void main()
    {
        vec4 modelPosition = modelMatrix * vec4(position,1.0);

        // wave

        float elevation = sin(modelPosition.x * uFrequency.x - uTime) * 0.1;
        elevation += sin(modelPosition.y * uFrequency.y - uTime) * 0.1;

        modelPosition.z += elevation;

      

       

        // modelPosition.z += aRandom * 0.1;
        // modelPosition.z += sin(modelPosition.z * 10.0) * 0.7;
        // modelPosition.x += sin(modelPosition.x * 10.0) * 0.1;




        vec4 viewPosition = viewMatrix * modelPosition;
        vec4 projectedPosition = projectionMatrix * viewPosition;

        gl_Position = projectedPosition;

        vUv = uv;
        vElevation = elevation;

        // vRandom = aRandom;
    }